var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class FactAPI {
    constructor() {
        // private apiURL = "http://localhost:3000/api/v1"
        this.apiURL = "https://vegan-facts-api.bendavisapps.co.uk/api/v1";
    }
    getFact(factID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.apiURL + `/fact/${factID}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch fact ${factID}, status code ${response.status}`);
            }
            return response.json();
        });
    }
}
//# sourceMappingURL=FactAPI.js.map